// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__22eC8","containerItemsCenter":"Skeleton_containerItemsCenter__1VHuN"};